import { isTokenValidate } from "Helpers/ats.helper";
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Gates a protected route. If the JWT in localStorage is missing/expired, redirect to the login.
 * Cleanup of localStorage / user state is handled by UserContext and the API middleware —
 * keeping this wrapper purely declarative avoids re-render loops.
 */
const TokenValidationWrapper = ({ Component, redirectPath = "/" }) => {
  const auth = localStorage.getItem("Authorization");

  if (!isTokenValidate(auth)) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Component />;
};

export default TokenValidationWrapper;
